const key = 'MODBUS_MAPS__';

exports.SET_IS_EDIT_DEFAULT = `${key}SET_IS_EDIT_DEFAULT`;
exports.SET_CREATE_EDIT_VALUES = `${key}SET_CREATE_EDIT_VALUES`;

exports.ADD_CREATE_EDIT_VALUES_GROUP_MAPS = `${key}ADD_CREATE_EDIT_VALUES_GROUP_MAPS`;
exports.REMOVE_CREATE_EDIT_VALUES_GROUP_MAPS = `${key}REMOVE_CREATE_EDIT_VALUES_GROUP_MAPS`;

exports.ADD_CREATE_EDIT_VALUES_GROUP_VARIABLES = `${key}ADD_CREATE_EDIT_VALUES_GROUP_VARIABLES`;
exports.REMOVE_CREATE_EDIT_VALUES_GROUP_VARIABLES = `${key}REMOVE_CREATE_EDIT_VALUES_GROUP_VARIABLES`;
